import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

export const ModalContainer = ({ open, handleClose, children }) => {

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        maxHeight: '80vh',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
        '-ms-overflow-style': 'none',
      }}>
        {children}
      </Box>
    </Modal>
  );
}